export function getJobMetaTags(): {
  head: Parameters<typeof useHead>[0];
  seo: Parameters<typeof useSeoMeta>[0];
} {
  const { t } = useI18n();
  const projectConfig = useProjectConfig();
  const config = useRuntimeConfig();
  const job = jobRepository.use();
  const siteName = (config.public.project as any)?.title || (config.public.project as any)?.name || 'Site';
  
  const jobTitle = computed(() => {
    const pageName = [
      job.value?.title,
      job.value?.location.summary,
      job.value?.organization === 'incognito'
        ? t('ORGANIZATION_INCOGNITO')
        : job.value?.organization.name,
    ]
      .filter((v) => !!v)
      .join(' | ');
    
    return `${pageName} | ${siteName}`;
  });
  const jobDescription = computed(() => {
    const description = job.value?.description ?? '';
    return description.length > 100 ? `${description.substring(0, 97)}...` : description;
  });
  const organizationImage = computed(() =>
    job.value?.organization === 'incognito'
      ? projectConfig.parameters.jobForClientShare
      : job.value?.organization.logoUrl
          ?.replace(/-\d+x\d+x\d+./, '-600x315x85.')
          .replace(/-fit-/, '-frame-') ?? undefined,
  );

  const noindex = computed(() => {
    const noindex = job.value?.noindex ?? false;
    if (noindex == false) {
      return {};
    }
    return { name: 'robots', content: 'noindex' };
  });

  return {
    head: {
      title: jobTitle,
      meta: [{ name: 'description', content: jobDescription }, noindex],
    },
    seo: {
      ogTitle: jobTitle,
      ogDescription: jobDescription,
      ogType: 'website',
      ogImage: organizationImage.value,
      ogImageWidth: 600,
      ogImageHeight: 315,
    },
  };
}
